// extracted by mini-css-extract-plugin
export default {"empty":"EmptyServerPage_empty__ymfWh"};